import { render, staticRenderFns } from "./userManagerOrg.vue?vue&type=template&id=3b0846e2&scoped=true&"
import script from "./userManagerOrg.vue?vue&type=script&lang=js&"
export * from "./userManagerOrg.vue?vue&type=script&lang=js&"
import style0 from "./userManagerOrg.vue?vue&type=style&index=0&id=3b0846e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0846e2",
  null
  
)

export default component.exports